import { render, staticRenderFns } from "./diagnostics_pc.vue?vue&type=template&id=8d2d67c6&scoped=true&"
import script from "./diagnostics_pc.vue?vue&type=script&lang=js&"
export * from "./diagnostics_pc.vue?vue&type=script&lang=js&"
import style0 from "./diagnostics_pc.vue?vue&type=style&index=0&id=8d2d67c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2d67c6",
  null
  
)

export default component.exports